<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 10c0-3 1.8-5 4-5v2c-1.2 0-2 1-2 2h2v5H7v-4ZM15 10c0-3 1.8-5 4-5v2c-1.2 0-2 1-2 2h2v5h-4v-4Z" fill="currentColor"/>
</svg>
</template>
